module.exports = __webpack_public_path__ + "img/bolsa-auxilio.6ec44df3.svg";